export default {"src":"/_next/static/media/sub.6ef88def.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};